import {
  OFFER_CATALOG_FETCH,
  OFFER_CATALOG_SAVE,
  OFFER_CATALOG_FAILURE,
  OFFER_CATALOG_RESET,
  OFFER_SUBSCRIPTION_REQUEST,
  OFFER_SUBSCRIPTION_SUCCESS,
  OFFER_SUBSCRIPTION_FAILURE,
  OFFER_SUBSCRIPTION_RESET,
} from "../constants/actionTypes";

const doFetchOfferCatalog = () => ({
  type: OFFER_CATALOG_FETCH,
});

const doSaveOfferCatalog = payload => ({
  type: OFFER_CATALOG_SAVE,
  payload,
});

const doSaveOfferCatalogFailure = payload => ({
  type: OFFER_CATALOG_FAILURE,
  payload,
});

const doResetOfferCatalog = () => ({
  type: OFFER_CATALOG_RESET,
});

const doRequestOfferSubscription = (offerId, productType) => ({
  type: OFFER_SUBSCRIPTION_REQUEST,
  payload: { offerId, productType },
});

const doSaveOfferSubscriptionSuccess = payload => ({
  type: OFFER_SUBSCRIPTION_SUCCESS,
  payload,
});

const doSaveOfferSubscriptionFailure = payload => ({
  type: OFFER_SUBSCRIPTION_FAILURE,
  payload,
});

const doResetOfferSubscription = () => ({
  type: OFFER_SUBSCRIPTION_RESET,
});

export {
  doFetchOfferCatalog,
  doSaveOfferCatalog,
  doSaveOfferCatalogFailure,
  doResetOfferCatalog,
  doRequestOfferSubscription,
  doSaveOfferSubscriptionSuccess,
  doSaveOfferSubscriptionFailure,
  doResetOfferSubscription,
};
